export const viewTypes = {
  detail: 1,
  mosaic: 2
}
